
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-talent",
      function () {
        return require("private-next-pages/our-talent/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-talent"])
      });
    }
  